import { IcpFooter } from "@/components/shared/IcpFooter";
import { PublicHeader } from "@/components/shared/PublicHeader";
import { landingPathFor } from "@/lib/constants/roles";
import { useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { LoginForm } from "./-LoginForm";

export function LoginPage() {
  const { redirect, error } = useSearch({ from: "/login" });
  const { isAuthenticated, isPending, user, signOut } = useAuth();

  useEffect(() => {
    if (!isPending && isAuthenticated && !error) {
      const landingPath = landingPathFor(user?.role);
      let redirectTo: string;
      if (redirect) {
        redirectTo = redirect;
      } else if (landingPath) {
        redirectTo = landingPath;
      } else {
        signOut();
        window.location.href = "/login?error=role_not_allowed";
        return;
      }
      window.location.href = redirectTo;
    }
  }, [isAuthenticated, isPending, user, redirect, error, signOut]);

  if (isPending || isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto" />
          <p className="mt-4 body text-gray-500">{isPending ? "Loading..." : "Redirecting..."}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <PublicHeader activePage="login" />
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12">
        <div className="w-full max-w-lg bg-white rounded-2xl border border-gray-100 shadow-sm px-8 py-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-1">Welcome back</h2>
          <p className="text-sm text-gray-500 mb-8">Sign in to your account</p>

          {error === "role_not_allowed" && (
            <div className="rounded-lg bg-error-50 border border-error-200 p-3 mb-6">
              <p className="text-sm text-error-600 text-center">
                Your role doesn't allow access at the moment.
              </p>
            </div>
          )}

          <LoginForm />
        </div>
      </div>
      <IcpFooter />
    </div>
  );
}
